<template>
  <fieldset
    class="border-2 border-secondary text-start rounded-md max-w-3xl mx-auto p-8"
  >
    <legend class="relative px-3 text-lg font-bold text-secondary ml-20">
      <NuxtImg
        loading="lazy"
        src="/icons/did-you-know.svg"
        alt=""
        class="absolute -left-20 top-[50%] translate-y-[-50%]"
        draggable="false"
        width="55"
        height="55"
      />
      {{ $t("pressEnquiryBlock.title") }}
    </legend>
    <p class="-mx-3 md:mx-0 md:px-7 md:pb-5">
      {{ $t("pressEnquiryBlock.contactLinkBefore") }}
      <NuxtLinkLocale
        :locale="switchBlogLocale()"
        :to="'/contact-us'"
        class="underline text-secondary hover:no-underline focus:no-underline"
        >{{ $t("pressEnquiryBlock.contactLink") }}</NuxtLinkLocale
      >
      {{ $t("pressEnquiryBlock.contactLinkAfter") }}
    </p>
  </fieldset>
</template>
